import {
    IComponentController,
    IComponentOptions,
    IOnChangesObject,
} from 'angular';
import { IFunctionBinding, IVFInfo, IVFInstance } from '../../../classes';

/**
 * This component allows a user to select from Default, Custom, or a Named Instance of a varaible font.
 *
 */

export interface VariableInstanceSelectComponentOnChanged {
    value: IVFInstance;
}

export class VariableInstanceSelectComponent implements IComponentController {
    info?: IVFInfo;
    onChanged?: IFunctionBinding<VariableInstanceSelectComponentOnChanged>;
    // show the custom option, this will always appear first.
    custom?: boolean = true;

    // this wil be the name of the instance.
    _selectedInstance?: IVFInstance;

    $onChanges(changes: IOnChangesObject): void {
        // console.log('VariableInstanceSelectComponent.$onChanges', changes);
        if (changes.instances) {
            this._selectedInstance = undefined;
        }
        if (changes.value) {
            this._selectedInstance = changes.value.currentValue;
        }
    }

    changed(value: IVFInstance): void {
        this._selectedInstance = value;
        // console.log('VariableInstanceSelectComponent.changed', this._selectedInstance)
        this.onChanged && this.onChanged({ value });
    }
}

export const VariableInstanceSelectComponentOptions: IComponentOptions = {
    controller: VariableInstanceSelectComponent,
    bindings: {
        info: '<',
        value: '<',
        onChanged: '&',
    },
    template: `
    <tn-select-3
        ng-if="$ctrl.info.instances && $ctrl.info.instances.length > 0"
        options="$ctrl.info.instances"
        label-prop="name"
        model="$ctrl._selectedInstance"
        placeholder="{{ $ctrl.custom && 'Custom' || undefined }}"
        on-changed="$ctrl.changed(value)"
    ></tn-select-3>
`,
};
